import { createAPI } from "../apisServer";

import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqEmpresaItens = {
	listItens: async function () {
		return apiServer
			.get(`portal/v1/empresa-itens`, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listOrderSumary: async function (param, paramValue) {
		return apiServer
			.get(`portal/v1/empresa-itens/order-sumary`, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listModulos: async function (idEmpresa) {
		return apiServer
			.get(`portal/v1/empresa/${idEmpresa}/modulos`, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	saveModulo: async function (idEmpresa, data) {
		return apiServer
			.post(`portal/v1/empresa/${idEmpresa}/modulos`, data, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	removeModulo: async function (idEmpresa, idItem) {
		return apiServer
			.delete(`portal/v1/empresa/${idEmpresa}/modulos/${idItem}`, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqEmpresaItens;
